export const Track = {
  PAGE_VIEW: 'track_pageview',
  SESSIONS: 'track_sessions',
  USER_DETAILS: 'user_details',
  ADD_EVENT: 'add_event',
} as const;

export type Countly = {
  add_event: ({
    count,
    dur,
    key,
    segmentation,
    sum,
  }: {
    count?: number;
    dur?: number;
    key: string;
    segmentation?: Record<string, unknown>;
    sum?: number;
  }) => void;
  api_key?: string;
  app_key?: string;
  app_version?: string;
  debug?: boolean;
  getViewName?: () => string;
  getViewUrl?: <T>(step: T) => string;
  inactivity_time?: number;
  init: () => void;
  name_space?: string;
  q: Array<unknown>;
  require_consent?: boolean;
  session_update?: number;
  url?: string;
  use_session_cookie?: boolean;
};
